export const maximumNumberOfPoints = 250; //単位は 個/1ルート
export const maximumDistanceValueOfSaved = 3000 * 1000; //単位はmeter
